import { clearStoredUser, getStoredUser, setStoredUser, useState,
        useQueryClient} from '@/imports-files/hooks/use-user';


export function useUser() 
{
  const [user, setUser] = useState(getStoredUser());
  const queryClient     = useQueryClient();

  // meant to be called from useAuth
  function updateUser(newUser) 
  {
    // set user in state
    setUser(newUser);

    // update user in localstorage
    setStoredUser(newUser);

    queryClient.setQueryData('userData', newUser);
  }

  // meant to be called from useAuth
  function clearUser() {
    // update state
    setUser(null);

    // remove from localstorage
    clearStoredUser();

    queryClient.setQueryData('userData', null);
  }

  return {user, updateUser, clearUser};
}
